import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { Delete, Edit } from "@mui/icons-material";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { Button, Modal, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { MyToDisableForm } from "../../components";
import { Loading } from "../../components/Loading";
import { MyRenderCell } from "../../components/MyRenderCell";
import { createActivity, IActivity } from "../../models/activities";
import { createEntityToDisable, IEntityToDisable } from "../../models/entityToDisable";
import { disableActivity, getActivities } from "../../redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { RootState } from '../../redux/store';
import { MyBoxModal } from "../../styled-components";
import { MyForm } from './components';

export const Activities = () => {
    const navigate = useNavigate();

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);

    const [disableOpen, setDisableOpen] = useState(false);
    const openDisableDialog = () => setDisableOpen(!disableOpen);

    const [editing, setEditing] = useState(false);

    const [activityToEdit, setActivityToEdit] = useState(createActivity({}));
    const [entityToDisable, setEntityToDisable] = useState(createEntityToDisable({}));

    const [pageSize, setPageSize] = useState<number>(10);

    const dispatch = useAppDispatch();
    const { isLoading, activities = [] } = useAppSelector((state: RootState) => state.activities);

    useEffect(() => {
        dispatch(getActivities() as any);
    }, [dispatch])

    const onDisableDialog = (activity: IActivity) => {
        setEntityToDisable(createEntityToDisable(activity));
        setEditing(true);
        openDisableDialog();
    }

    const onEdit = (activity: IActivity) => {
        setActivityToEdit(createActivity(activity));
        setEditing(true);
        openDialog();
    }
    const onCreate = () => {
        setActivityToEdit(createActivity({}));
        setEditing(false);
        openDialog();
    }

    const onDisable = (values: IEntityToDisable) => {
        dispatch(disableActivity(values) as any);
    }

    const Columns: GridColDef[] = [
        {
            field: "action",
            headerName: "Actions",
            width: 210,
            sortable: false,
            align: "right",
            renderCell: (params) => {
                const onClick = (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation(); // don't select this row after clicking

                    onEdit(params.row as any);
                };
                const disableActivity = (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation(); // don't select this row after clicking

                    onDisableDialog(params.row as any);
                };
                const addItems = (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation(); // don't select this row after clicking

                    navigate("/activities/" + params.row.id);
                };
                return (
                    <>
                        <Tooltip title="Edit" >
                            <Button onClick={onClick}><Edit /></Button>
                        </Tooltip>
                        <Tooltip title="Disable" >
                            <Button onClick={disableActivity}><Delete /></Button>
                        </Tooltip>
                        <Tooltip title="Add Sub Activities" >
                            <Button onClick={addItems}><FormatListNumberedIcon /></Button>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: 'id',
            headerName: 'id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activeUntilDate',
            headerName: 'Active Until Date',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
    ]

    return (
        <div>
            <Loading isLoading={isLoading} />
            <Typography variant="h4" component="h1">Activities</Typography>
            <br />
            <Button onClick={onCreate}>Add</Button>
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid
                    rows={activities}
                    columns={Columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 50, 100]}
                    columnVisibilityModel={{ id: false, }}
                //checkboxSelection
                />
            </div>
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} activity={activityToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
            <Modal open={disableOpen} onClose={openDisableDialog}>
                <MyBoxModal>
                    <MyToDisableForm onCancel={openDisableDialog} entity={entityToDisable} onDisable={onDisable} />
                </MyBoxModal>
            </Modal>
        </div>
    )
}
